import { Outlet } from 'react-router-dom'
import AdminAccessState from './AdminAccessState'
import { useAdminSession } from '@hooks/useAdminSession'

export default function AdminRouteGuard() {
  const { status, ready, refresh } = useAdminSession()

  if (!ready) {
    return <AdminAccessState state={status} onRetry={refresh} />
  }

  return <Outlet />
}
